import { animate, style, transition, trigger } from '@angular/animations';
import { Component, DestroyRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Point } from 'geojson';
import { LatLngBounds } from 'leaflet';
import { MapComponent } from 'src/app/components/geo/map/map.component';
import { API, CoordinateClusterDTO, GeoCullDTO, PlayerCullDTO, ScreenScope } from 'src/app/services/api/api';
import { UtilService } from 'src/app/services/util.service';
import { ErrorService } from '../../../services/error.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-cluster-map-legacy',
  templateUrl: './sb-cluster-map-legacy.component.html',
  styleUrls: ['./sb-cluster-map-legacy.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate(250, style({ opacity: 1 }))]),
      transition(':leave', [animate(500, style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class SbClusterMapLegacyComponent implements OnInit, OnChanges {
  @Input() playerCull: PlayerCullDTO[];
  @Input() geoCull: GeoCullDTO[];
  @Input() mapHeight: number;
  @Input({ required: true }) scope: ScreenScope;

  loading: boolean;
  debounceTimer: ReturnType<typeof setTimeout> = null;
  clusters: CoordinateClusterDTO[];

  min: Point;
  max: Point;

  mapComponent: MapComponent;

  constructor(
    private api: API,
    public errorHandler: ErrorService,
    public util: UtilService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.loading = false;
  }

  refresh() {
    this.requestDebounced();
  }

  requestDebounced() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.request();
    }, 1000);
  }

  request() {
    this.loading = true;

    let playerCullIDs;
    if (this.playerCull && this.playerCull[0]) {
      playerCullIDs = this.playerCull.map(x => x?.id);
    }
    let geoCullIDs;
    if (this.geoCull && this.geoCull[0]) {
      geoCullIDs = this.geoCull.map(x => x.id);
    }
    // TODO ADD SUPPORT FOR GEO CULL?
    this.api
      .cs_PlayerCull_coordinateCluster({
        screenScope: this.scope ?? ScreenScope.ALL,
        min: this.min,
        max: this.max,
        playerCull: this.playerCull ? playerCullIDs : [],
      })
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: (e: CoordinateClusterDTO[]) => {
          this.clusters = e;
          this.loading = false;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }

  mapReady(mapComponent: MapComponent) {
    this.mapComponent = mapComponent;
  }

  refreshBounds() {
    if (this.mapComponent) {
      const boundingRectangle: LatLngBounds = this.mapComponent.getBoundingRectangle();
      if (boundingRectangle) {
        this.min = this.util.geo.createPoint(boundingRectangle.getWest(), boundingRectangle.getNorth());
        this.max = this.util.geo.createPoint(boundingRectangle.getEast(), boundingRectangle.getSouth());
      }
      this.refresh();
    }
  }

  getMapZoom() {
    return 6;
  }

  getMapCenter() {
    return { x: 10.447683, y: 51.163361 };
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.refresh();
  }
}
